import { render, staticRenderFns } from "./Detail-Company-Equipment.vue?vue&type=template&id=148e8cbb"
import script from "./Detail-Company-Equipment.vue?vue&type=script&lang=js"
export * from "./Detail-Company-Equipment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports